// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"606984b7","180":"34db9548","208":"66f257a7","419":"8faa941f","439":"0fa11b52","631":"c896f787","774":"de39b38b","854":"5926c9d5"}[chunkId] + ".chunk.js";
};